import styled from 'styled-components';
import { rem } from 'polished';
import { ModalFeatureDemandStyled } from '../ModalFeatureDemandStyled';

export const ModalFeatureDemandStyledAC = styled(ModalFeatureDemandStyled)``;
